module.exports = __webpack_public_path__ + "img/tu2.1074e41a.png";